$(window).on("load", function () {
    $('.btn-forget').on('click', function (e) {
        e.preventDefault();
        $('.form-items', '.form-content').addClass('hide-it');
        $('.form-sent', '.form-content').addClass('show-it');
    });
});

$(function () {
    var appUrl = $('#mainPane').data('appurl') || '',
        checkUri = $('#mainPane').data('checkuri') || '',
        sessionAccountsCount = 0,
        processedSessionAccountsCount = 0,
        lockProgressActivity = false,
        appMethods = {
            addAccount: function (name, desc, link) {
                var $accountEl = $('.account-picker-pane .dummy').clone();
                $accountEl.attr('href', link);
                $('.account-block-name', $accountEl).html(name);
                $('.account-block-desc', $accountEl).html(desc);
                $accountEl.removeClass('dummy');
                $accountEl.prependTo('.account-picker-pane');
            },
            addSession: function (url) {
                var currentSession = Cookies.get('anyrent_domain'),
                    alreadyExists = false;

                if (currentSession !== undefined) {
                    currentSession = currentSession.split("|");
                    $.each(currentSession, function (key, value) {
                        if (value === url) {
                            alreadyExists = true;
                        }
                    });

                    if (!alreadyExists) {
                        currentSession.push(url);
                        Cookies.set('anyrent_domain', currentSession.join("|"), {expires: false, path: ''});
                    }
                } else {
                    Cookies.set('anyrent_domain', url, {expires: false, path: ''});
                }
            },
            removeSession: function (url) {
                var currentSession = Cookies.get('anyrent_domain');

                if (currentSession !== undefined) {
                    currentSession = currentSession.split("|");
                    $.each(currentSession, function (key, value) {
                        if (value === url) {
                            currentSession.splice(0, key + 1);
                            Cookies.set('anyrent_domain', currentSession.join("|"), {expires: false, path: ''});
                            return false;
                        }
                    });
                }
            },
            updateLoadingPane: function () {
                processedSessionAccountsCount++;
                if (processedSessionAccountsCount >= sessionAccountsCount) {
                    $('.main-pane').removeClass('progress-active');
                }
            }
        };

    window.loadAccount = function (el) {
        $(el).addClass('loading');
    };

    // --- BLOCO DOS PINGS (multi-instância) ---
    if ($('#check').length && appUrl && checkUri) {

        // appUrl vem como "https://dev.s10.anyrent.pt|https://dev.s11.anyrent.pt"
        var appUrlParts = appUrl.split("|").filter(function (v) {
            return v && v.trim() !== '';
        });

        sessionAccountsCount = appUrlParts.length;

        if (sessionAccountsCount) {

            $.each(appUrlParts, function (key, value) {
                var baseUrl = value.replace(/\/+$/, ''); // remove "/" final se existir

                $('#ping' + key).on('load', function () {
                    $('.main-pane').addClass('has-accounts');

                    var hostname = baseUrl.replace(/http:\/\/|https:\/\//g, ''),
                        companyCode = hostname.split(".")[0];

                    // Aqui podes decidir se o link é o baseUrl ou outra coisa
                    appMethods.addAccount(companyCode, hostname, baseUrl);
                    appMethods.updateLoadingPane();

                }).on('error', function () {
                    if (!lockProgressActivity) {
                        $('.main-pane').removeClass('progress-active');
                    }
                    appMethods.removeSession(baseUrl);
                    Cookies.remove('anyrent_domain', {path: ''});
                });
            });

            setTimeout(function () {
                $.each(appUrlParts, function (key, value) {
                    var baseUrl = value.replace(/\/+$/, '');
                    $('#ping' + key).attr('src', baseUrl + checkUri);
                });
            }, 1000);

        } else {
            setTimeout(function () {
                if (!lockProgressActivity) {
                    $('.main-pane').removeClass('progress-active');
                }
            }, 1500);
            Cookies.remove('anyrent_domain', {path: ''});
        }
    } else {
        // Não há appUrl ou checkUri -> comportamento antigo (sem sessões ativas)
        setTimeout(function () {
            if (!lockProgressActivity) {
                $('.main-pane').removeClass('progress-active');
            }
        }, 1500);
        Cookies.remove('anyrent_domain', {path: ''});
    }

    // --- resto do teu JS (Ladda + submit) fica igual ---
    var $progressEl = null,
        progressInstance = null;

    Ladda.bind('.ladda-button', {
        callback: function (instance, element) {
            var progress = 0;

            $progressEl = $(element);
            progressInstance = instance;

            if ($progressEl.data('progress') != false) {
                var interval = setInterval(function () {
                    progress = Math.min(progress + Math.random() * 0.1, 1);
                    instance.setProgress(progress);

                    if (progress === 1) {
                        clearInterval(interval);
                    }
                }, 200);
            } else {
                instance.setProgress(0);
            }

            $(window).off('btnloader.stop').on('btnloader.stop', function () {
                if ($progressEl.data('progress') != false) {
                    progress = 1;
                    clearInterval(interval);
                }
                progressInstance.stop();
            });
        }
    });

    $('#toggleSigninForm').on('click', function () {
        $('.main-pane').addClass('multi-session').removeClass('has-accounts');
    });

    $("form").submit(function (e) {
        var form = $(this);
        var url = form.attr('action');

        $.ajax({
            type: "POST",
            url: url,
            data: form.serialize(),
            success: function (data) {
                if (data.status == 'ok') {

                    if (data.hasOwnProperty('sca_verify_url') && data.sca_verify_url) {
                        window.location.href = data.sca_verify_url;
                    } else {
                        if (data.hasOwnProperty('ping_before_redirect') && data.ping_before_redirect) {

                            $('#ping0').off('load').on('load', function () {
                                if (data.external_url) {
                                    $('#pingExternal').off('load').on('load', function () {
                                        appMethods.addSession(data.redirect_url);
                                        window.location.href = data.redirect_url;
                                    }).on('error', function () {
                                        appMethods.addSession(data.redirect_url);
                                        window.location.href = data.redirect_url;
                                    });

                                    $('#pingExternal').attr('src', data.external_url);
                                } else {
                                    appMethods.addSession(data.redirect_url);
                                    window.location.href = data.redirect_url;
                                }
                            }).on('error', function () {
                                new Noty({
                                    theme: 'metroui',
                                    type: 'error',
                                    text: 'Não foi possível concluir a autenticação. Tente novamente por favor.',
                                    progressBar: true,
                                    timeout: 5000
                                }).show();
                                $(window).trigger('btnloader.stop');
                            });

                            $('#ping0').attr('src', data.content);

                        } else {
                            if (data.mode === 'sso' && data.redirect_url) {
                                appMethods.addSession(data.redirect_url);
                                setTimeout(function () {
                                    window.location.href = data.redirect_url;
                                }, 1000);
                            } else {
                                new Noty({
                                    theme: 'metroui',
                                    type: 'error',
                                    text: data.content,
                                    progressBar: true,
                                    timeout: 5000
                                }).show();

                                if (data.redirect_url) {
                                    setTimeout(function () {
                                        window.location.href = data.redirect_url;
                                    }, 5500);
                                }
                            }
                        }
                    }

                } else {
                    new Noty({
                        theme: 'metroui',
                        type: 'error',
                        text: data.content,
                        progressBar: true,
                        timeout: 5000
                    }).show();
                }
            }
        }).done(function (data) {
            if (!data.hasOwnProperty('keep_loading_on_redirect') || !data.keep_loading_on_redirect) {
                $(window).trigger('btnloader.stop');
            }
        });

        e.preventDefault();
    });
});